exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.roomTile {\n  background-color: #ffffff;\n}\n.unitContainer {\n  background-color: #ebebeb;\n  height: 100%;\n  padding: 5px;\n}\n", ""]);

// exports
